module.exports = __webpack_public_path__ + "images/emoji/european_castle.418d353ebe2fba31366f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/european_castle.png
// module id = G26K
// module chunks = 1